'use strict';

$(document).ready(function () {
    var freeTextSearchResult = (typeof(freeTextSearch) !== 'undefined' && freeTextSearch ? freeTextSearch.trim() : '');
    var keyword = freeTextSearchResult.split(':')[0];

    var totalResults = 0;
    var didYouMean = false;
    var arrLength = $('.searchOnlineResults').length;
    if (sessionStorage.getItem('isFromFilter') === 'true') {
        sessionStorage.removeItem('isFromFilter');
    } else if (arrLength > 0 && keyword !== '') {
        $('.searchOnlineResults').each(function (index) {
            totalResults += parseInt($(this).data('total-results'));
            if((typeof(isDidYouMeanTextSearch) !== 'undefined' && isDidYouMeanTextSearch) || $(this).attr('data-did-you-mean')) {
                didYouMean = true;
            }
            if ((index == (arrLength - 1))) {
                push_search_result_metrics(keyword, totalResults, didYouMean);
            }
        });
    } else if (typeof(noResults) !== 'undefined' && noResults) {
        push_search_result_metrics(keyword, 0, false);
    }

    $('input[type=search]').each( function () {
        // refer to main.js
        manageSearchButtonWithEraseButton($(this));
    });
});

